export function isClaimOptionVisible(isClaimable: LSCommon.Service.LSWebUI.Models.XPP.Claimable) {
   return isClaimable == LSCommon.Service.LSWebUI.Models.XPP.Claimable.ClaimableWithValidSecret
      || isClaimable == LSCommon.Service.LSWebUI.Models.XPP.Claimable.ClaimableJustProvideOption
}
